<template>

  <div>
    <nav-breadcrumb :menu="[{label:  '还款申请查询'}]"/>
    <el-steps  class="step-shenpi" :active="1000">
      <el-step :title="'提交减免'" :description = "$moment(repayInfo.t__applicationDate).format('YYYY-MM-DD HH:mm:ss')">
        <i class="step-start" slot="icon"></i>
      </el-step>
<!--      <el-step v-if="approvalList.length>0" :title="Status2CN(approvalList[0].a__approvalType)+approvalList[0].a__approverName" :description="$moment(approvalList[0].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[0].a__approvingStatus)" >
        <i class="step-mid" slot="icon"></i>
      </el-step>

      <el-step v-if="approvalList.length>1" :title="Status2CN(approvalList[1].a__approvalType)+approvalList[1].a__approverName" :description="$moment(approvalList[1].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[1].a__approvingStatus)" >
        <i class="step-mid" slot="icon"></i>
      </el-step>-->

      <el-step v-for="(item, idx) in (repayInfo.approvals||[]).filter(item=>item.a__approvingDate)" class="step-spec" :description="$moment(item.a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(item.a__approvingStatus)" :key="idx" >
        <i class="step-mid" slot="icon"></i>
        <div slot="title">{{Status2CN(item.a__approvalType)}} <br />{{item.a__approverName}}</div>
      </el-step>
      <el-step :title="'完成'" v-if="repayInfo.t__applicationStatus == 'Approved'" >
        <i class="step-over" slot="icon"></i>
      </el-step>
      <el-step :title="'完成'" v-if="repayInfo.t__applicationStatus == 'Completed'" >
        <i class="step-over" slot="icon"></i>
      </el-step>
      <el-step :title="'否决'" v-if="repayInfo.t__applicationStatus == 'Rejected'" >
        <i class="step-over" slot="icon"></i>
      </el-step>
    </el-steps>
    <repay-for-approval :financing-detail="repayInfo" :transfer-repayment-detail="repayInfo" :editable="false" :repay-plan-list="repayInfo.detail" @close="repayForApprovalDialogVisible=false"></repay-for-approval>
    <panel title="">
      <panel>备注：{{repayInfo.t__remarks}}</panel>

      <panel><data-table
        :table-data="approvalArry"
        :columns="tableColumns"
        :is-pagination-show="false"
      /></panel>
    </panel>
    <div class="tr xzmt">
      <el-button @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>

<script>
  import RepayForApproval from "../components/RepayForApproval";
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Panel from "../../components/Panel";
  import Status2CN from "../../filters/Status2CN";
  export default {
    name: "ApplyingRepaymentEdit",
    components: {Panel, RepayForApproval},
    data(){
      return{
        approvalListcount:0,
        approvalList:[],
        approvalArry:{
          data:[],
          count:0,
        },
        repayInfo:{},
        applicationId:this.$route.query['applicationId']||'',
        tableColumns: [
          {
            label: '节点',
            field: 'node',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            label: '操作人',
            field: 'approverName'
          },
          {
            label: '操作时间',
            field: 'time',
            formatter: function (r,c,v) {
              return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''
            }
          },
          {
            label: '操作结果',
            field: 'status'
          }, {
            label: '操作备注',
            field: 'remarks'
          },

        ],
      }
    },
    mounted() {
      this.getData()

    },
    methods:{
      Status2CN,
      getData: function () {
        xhr.getViewRepayForApproval(
          {
            't.applicationId': this.applicationId
          },
          res => {
            const repayInfo = res.data.data || {}
            this.repayInfo = repayInfo
            this.repayInfo.de__txDate= moment(repayInfo.t__repayDate).format('YYYY-MM-DD HH:mm:ss')
            this.approvalArry.data.push(
              {
                node:'提交减免',
                approverName:this.repayInfo.createdBy__userName,
                time:this.repayInfo.t__applicationDate,
                status:'提交成功',
                remarks:'',

              }
            )
            res.data.data.approvals.forEach(item=>{
              console.log(item)
              if(item.a__approvalId){
                this.approvalList.push(item)
                this.approvalArry.data.push(
                  {
                    node:item.a__approvalType,
                    approverName:item.a__approverName,
                    time:item.a__approvingDate,
                    status:Status2CN(item.a__approvingStatus),
                    remarks:item.a__remarks,

                  }
                )
              }
            })
            this.approvalList.count = this.approvalList.length
            console.log(this.approvalList)
            console.log('******************')
          }
        )
      },
      updateApproveRepayment:function (status){
        const form ={}
        form.t__applicationId = this.applicationId
        form.a__applicationId = this.applicationId
        form.a__approvingStatus=status
        form.a__remarks = this.repayInfo.a__remarks
        form.t__checked = true
        xhr.updateApproveRepayment(
          form,
          res=> {
            try{
              if(res.data.status == 'success') {
                this.$router.push({
                  path: 'List',
                })
              }else{

                this.$message.error(res.data.msgs[0].text)
              }

            }catch (e) {

              this.$message.error(error.msgs[0].text)

            }
          }
        )
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ApplyingRepaymentView.vue